














import { Vue, Component } from 'vue-property-decorator';
import { GetMemberGradesRequest } from 'supporter';

@Component({
  components: {},
})
export default class DisplayInfo extends Vue {
  private content: any = [];

  private created(): void {
    this.getInfo();
  }
  private getInfo(): void {
    const targetType = this.$route.name === 'DisplayGradeInfoPopup' ? 'GRADE' : 'GROUP';
    const targets = this.$route.query[targetType === 'GRADE' ? 'grades' : 'groups'].toString().split(',');
    this.formatterList(targets);
  }
  private formatterList(arr: any): void {
    const request: GetMemberGradesRequest = {
      params: {
        mallNo: this.$route.query.mallNo as any,
      },
    };
    if (this.$route.name === 'DisplayGradeInfoPopup') {
      this.$api.getMemberGrades(request).then((res: any): any => {
        arr.map((item: any): any => {
          res.data.map((gItem: any): any => {
            if (item === gItem.no.toString()) {
              this.content.push(gItem.name);
            }
          });
        });
      });
    } else {
      this.$api.getMemberGroups(request).then((res: any): any => {
        arr.map((item: any): any => {
          res.data.map((gItem: any): any => {
            if (item === gItem.no.toString()) {
              this.content.push(gItem.name);
            }
          });
        });
      });
    }
  }
  private handleClose(): void {
    window.close();
  }
}
